export function toggleSubmitButtonsFor(selector) {
  const el = document.querySelector(selector);

  if (!el) return;

  if (el.tagName === 'BUTTON' || el.type === 'submit') {
    el.disabled = !el.disabled;
  } else {
    Array.from(el.querySelectorAll("button, input[type='submit']")).forEach(
      (button) => {
        button.disabled = !button.disabled;
      }
    );

    Array.from(el.getElementsByTagName('a')).forEach((link) => {
      link.dataset.disabled = !link.dataset.disabled;
    });
  }
}
